import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const slides = [
  {
    headline: (
      <>
        We design, build, and run <span className="text-[#FFA100] font-bold">software</span> and{' '}
        <span className="text-[#FFA100] font-bold">AI systems</span> for businesses
      </>
    ),
    body: 'Custom development, cloud architecture, and AI integration. We also operate our own B2B SaaS products in compliance, security, and operations.',
  },
  {
    headline: (
      <>
        Products we ship: <span className="text-[#FFA100] font-bold">Nisium</span>,{' '}
        <span className="text-[#FFA100] font-bold">SiloPass</span>,{' '}
        <span className="text-[#FFA100] font-bold">XnGo</span>
      </>
    ),
    body: 'Real platforms in production - not slideware. Explore what we build when we are not delivering for clients.',
  },
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-fixed px-4 py-24"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1606857521015-7f9fcf423740?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB0ZWNobm9sb2d5JTIwYnVzaW5lc3MlMjBwcm9mZXNzaW9uYWx8ZW58MXx8fHwxNzgxNjM1MjY1fDA&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral')`,
      }}
    >
      <div className="absolute inset-0 bg-black/60" />

      <div className="relative z-10 w-full max-w-3xl mx-auto text-center">
        <div className="bg-black/50 p-6 sm:p-8 md:p-12 rounded-lg">
          <div className="min-h-[220px] sm:min-h-[260px] md:min-h-[300px] flex flex-col justify-center">
            <h2 className="text-2xl sm:text-3xl md:text-5xl text-white mb-4 sm:mb-6 leading-tight">
              {slides[currentSlide].headline}
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-white/90 leading-relaxed">
              {slides[currentSlide].body}
            </p>
          </div>

          <div className="flex items-center justify-center gap-4 sm:gap-6 mt-6 sm:mt-8">
            <button
              onClick={prevSlide}
              className="text-white/70 hover:text-[#FFA100] transition-colors p-2"
              aria-label="Previous slide"
            >
              <ChevronLeft size={28} className="sm:w-8 sm:h-8" />
            </button>

            <div className="flex gap-2">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`h-3 rounded-full transition-all ${
                    currentSlide === index ? 'bg-[#FFA100] w-8' : 'bg-white/50 w-3'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextSlide}
              className="text-white/70 hover:text-[#FFA100] transition-colors p-2"
              aria-label="Next slide"
            >
              <ChevronRight size={28} className="sm:w-8 sm:h-8" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
